export enum AreraFileType {
    Conf = 'Conf', // Scheda di confrontabilità
    Sint = 'Sint'// Scheda sintetica
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/AreraFileType.ts